import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Breadcrumbs, Typography, Link } from '@material-ui/core'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import { useStyles } from './BreadcrumbsComponent.styles'

type Props = {
  crumbs: { label: string; path?: string }[]
}

const BreadcrumbsComponent = ({ crumbs }: Props) => {
  const classes = useStyles()
  return (
    <>
      <Breadcrumbs
        separator={
          <NavigateNextIcon fontSize="small" className={classes.label} />
        }
        aria-label="breadcrumb"
      >
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1
          if (isLast) {
            return (
              <Typography
                key={crumb.label + index}
                variant="body1"
                className={classes.label}
              >
                {crumb.label}
              </Typography>
            )
          }
          if (crumb.path) {
            return (
              <Link
                key={crumb.label + index}
                component={RouterLink}
                to={crumb.path}
                underline="none"
                className={classes.link}
              >
                <Typography variant="body1" className={classes.link}>
                  {crumb.label}
                </Typography>
              </Link>
            )
          }
          return (
            <Typography
              key={crumb.label + index}
              variant="body1"
              className={classes.label}
            >
              {crumb.label}
            </Typography>
          )
        })}
      </Breadcrumbs>
    </>
  )
}

export default BreadcrumbsComponent
